import { render, staticRenderFns } from "./ProcessTicket.vue?vue&type=template&id=06f61b47"
import script from "./ProcessTicket.vue?vue&type=script&lang=ts"
export * from "./ProcessTicket.vue?vue&type=script&lang=ts"
import style0 from "./ProcessTicket.vue?vue&type=style&index=0&id=06f61b47&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports